const CARE_SUFFIX = process.env.NEXT_PUBLIC_APP_ID === 'bznav-care' ? '.care' : '';

export const BZNAV_SESSION_ID = `B_SSID.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_CLIENT_SESSION_ID = `B_C_SSID.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_ACCESS_TOKEN = `B_AT${CARE_SUFFIX}.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_USER_DATA = `bznav_user_data${CARE_SUFFIX}.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_RETURN_URL = `bznav_return_url.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_AUTH_SESSION = `B_AS${CARE_SUFFIX}.${process.env.NEXT_PUBLIC_ZENV}`;
export const BZNAV_SIGN_IN_COMPLETE_EVENT_SENT_KEY = `B_SIGN_IN_COMPLETE_EVENT_SENT.${process.env.NEXT_PUBLIC_ZENV}`;
export const META_PIXEL_ACTION_SOURCE = 'bznav_meta_action_source';
export const META_PIXEL_BASIC_PROPERTIES = 'meta_pixel_basic_properties';
